// Enumerations
import { ModalReferencesEnumeration } from 'enumerations/modal-references.enumeration';
// Translations
import {
  LAYOUT_MODAL_CONTENT,
  LAYOUT_MODAL_TITLE,
} from '../translations/layout-footer-modal.translations';

const LAYOUT_FOOTER_MODAL_COMPONENT_PROPS = {
  description: LAYOUT_MODAL_CONTENT,
  id: ModalReferencesEnumeration.CANCEL_PROCESS,
  title: LAYOUT_MODAL_TITLE,
};

export { LAYOUT_FOOTER_MODAL_COMPONENT_PROPS };
